import React, { useEffect, useState } from "react";
import SearchResultHeading from "../components/b2c/SearchResultHeading";
import Header from "../components/landingPage/Header";
import PassengerDetailInputField from "../components/b2c/PassengerDetailInputField";
import {
  faEnvelope,
  faGlobe,
  faMobile,
  faUser,
  faUserCheck,
} from "@fortawesome/fontawesome-free-solid";
import {
  faListCheck,
  faPlaneArrival,
  faPlaneDeparture,
  faPlaneUp,
} from "@fortawesome/free-solid-svg-icons";
import CountryList from "country-list-with-dial-code-and-flag";
import { ArrowCircleLeftIcon } from "@heroicons/react/solid";
import { useDispatch, useSelector } from "react-redux";
import { setPassengerDetails } from "../redux/app/passenger/passenger";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import {
  setFlightArrivalDepartureData,
  setFlightArrivalDepartureErrorData,
  setFlightData,
} from "../redux/app/booking/booking-slice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingIcon from "../components/loading/LoadingIcon";

const PassengerDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    booking,
    flightArrivalDepartureData,
    flightArrivalDepartureErrorData,
    bookingInitiateLoading,
  } = useSelector((state) => state.booking);
  const [searchCountryCode, setsearchCountryCode] = useState("");
  const [checkFlight, setcheckFlight] = useState(false);

  const validateEmail = (email) => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const initialState = {
    firstname: "",
    lastname: "",
    email: "",
    country: "",
    dial_code: "",
    phone: "",
    flightOrTrain: "",
    reference: "",
    specialRequest: "",
    bookingId: booking.bookingId,
  };

  const [passenger, setPassenger] = React.useState(initialState);

  const [openContryCode, setopenContryCode] = useState(false);
  const [isPassengerDetailCheck, setisPassengerDetailCheck] = useState(false);

  // const confirmBookingHandler = () => {
  //   dispatch(setPassengerDetails({ passenger }));
  //   dispatch({
  //     type: "CONFIRM_BOOKING_WITH_PASSENGER_DETAIL",
  //     payload: { passenger, navigate },
  //   });
  // };

  useEffect(() => {
    dispatch(
      setFlightArrivalDepartureData({
        flightArrivalDepartureData: {},
      })
    );
    dispatch(
      setFlightArrivalDepartureErrorData({
        flightArrivalDepartureErrorData: "",
      })
    );
  }, []);

  const confirmBookingHandler = () => {
    if (
      passenger.firstname === "" ||
      passenger.lastname === "" ||
      passenger.email === "" ||
      passenger.country === "" ||
      passenger.phone === ""
      // passenger.flightOrTrain === ""
    ) {
      toast.warn("Please fill important the fields");
    } else {
      if (isPassengerDetailCheck) {
        if (
          booking?.source?.placename?.includes(
            flightArrivalDepartureData?.arrivalAirportFsCode
          ) ||
          booking?.destination?.placename?.includes(
            flightArrivalDepartureData?.departureAirportFsCode
          )
        ) {
          dispatch(setPassengerDetails({ passenger }));
          dispatch({
            type: "CONFIRM_BOOKING_WITH_PASSENGER_DETAIL",
            payload: { passenger, navigate },
          });
        } else if (
          !booking?.source?.placename?.includes(
            flightArrivalDepartureData?.arrivalAirportFsCode
          ) ||
          !booking?.destination?.placename?.includes(
            flightArrivalDepartureData?.departureAirportFsCode
          )
        ) {
          dispatch(setPassengerDetails({ passenger }));
          dispatch({
            type: "CONFIRM_BOOKING_WITH_PASSENGER_DETAIL",
            payload: { passenger, navigate },
          });
        } else {
          toast.warn("Please select correct flight");
        }
      } else {
        toast.warn("Please check if you agree terms & conditions");
      }
    }
  };

  useEffect(() => {
    if (passenger.flightOrTrain && checkFlight) {
      if (
        booking?.source?.placename?.includes("Airport") ||
        booking?.source?.placename?.includes("airport") ||
        booking?.source?.placename?.includes("AIRPORT") ||
        booking?.source?.placename?.includes("مَطَار") ||
        booking?.source?.placename?.includes("Aéroport") ||
        booking?.source?.placename?.includes("Aeroporto") ||
        booking?.source?.placename?.includes("Aeropuerto") ||
        booking?.source?.placename?.includes("Flughafen")
      ) {
        if (
          flightArrivalDepartureData?.arrivalAirportFsCode !== undefined &&
          !booking?.source?.placename?.includes(
            flightArrivalDepartureData?.arrivalAirportFsCode
          )
        ) {
          // toast.warn("Pickup location and flight arrival should same");
          dispatch(
            setFlightArrivalDepartureErrorData({
              flightArrivalDepartureErrorData:
                "Pickup location and flight arrival should be same",
            })
          );
        }
      } else if (
        booking?.destination?.placename?.includes("Airport") ||
        booking?.destination?.placename?.includes("airport") ||
        booking?.destination?.placename?.includes("AIRPORT") ||
        booking?.destination?.placename?.includes("مَطَار") ||
        booking?.destination?.placename?.includes("Aéroport") ||
        booking?.destination?.placename?.includes("Aeroporto") ||
        booking?.destination?.placename?.includes("Aeropuerto") ||
        booking?.destination?.placename?.includes("Flughafen")
      ) {
        if (
          flightArrivalDepartureData?.departureAirportFsCode !== undefined &&
          !booking?.destination?.placename?.includes(
            flightArrivalDepartureData?.departureAirportFsCode
          )
        ) {
          dispatch(
            setFlightArrivalDepartureErrorData({
              flightArrivalDepartureErrorData:
                "Pickup location and flight arrival should be same",
            })
          );
        }
      }
    }
  }, [
    booking?.source?.placename,
    flightArrivalDepartureData?.arrivalAirportFsCode,
    booking?.destination?.placename,
    flightArrivalDepartureData?.departureAirportFsCode,
    passenger.flightOrTrain,
    checkFlight,
    dispatch,
  ]);

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
      // window.location.pathname = "/newbooking";
    };
  }, []);

  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
    localStorage.setItem("relodePage", "true");
  };

  useEffect(() => {
    if (localStorage.getItem("relodePage")) {
      localStorage.removeItem("relodePage");
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="h-screen overflow-y-auto w-screen">
      <Header />
      <div className="mt-10 py-10 xl:mx-6 lg:mx-10">
        <div className="flex mt-5 space-x-5 mx-1 sm:mx-10 lg:mx-0 xl:mx-44">
          <div>
            <Link to="/">
              <ArrowCircleLeftIcon className="w-8 text-gray-600 mt-3" />
            </Link>
          </div>
          <SearchResultHeading
            searchCompleted={true}
            chVehicleCompleted={true}
            passengerCurrent={true}
            showBookingDetail={false}
          />
        </div>

        {/* passenger details field */}
        <div className="mx-10 xl:mx-56 mt-10 space-y-6 text-[15px]">
          <div className="mt-10 lg:flex space-y-5 lg:space-x-10 border-0 md:space-y-5 lg:space-y-0 sm:space-y-5">
            <div className="w-full grow">
              <PassengerDetailInputField
                label="First Name*"
                inputType="text"
                icon={faUser}
                placeHolder="Enter First name"
                onChange={(e) => {
                  setPassenger({ ...passenger, firstname: e.target.value });
                }}
                onClick={() => {
                  setopenContryCode(false);
                }}
              />
            </div>
            <div className="w-full grow">
              <PassengerDetailInputField
                label="Last Name*"
                icon={faUser}
                placeHolder="Enter Last name"
                onChange={(e) => {
                  setPassenger({ ...passenger, lastname: e.target.value });
                }}
                onClick={() => {
                  setopenContryCode(false);
                }}
              />
            </div>
          </div>
          <div className="md:flex-none lg:flex lg:space-x-10 space-y-5 lg:space-y-0 md:space-y-5 sm:space-y-5">
            <div className="w-full grow">
              <PassengerDetailInputField
                label="Email address*"
                inputType="email"
                icon={faEnvelope}
                placeHolder="Enter Email address"
                onChange={(e) => {
                  setPassenger({ ...passenger, email: e.target.value });
                }}
                onBlur={() => {
                  if (passenger.email) {
                    if (!validateEmail(passenger.email)) {
                      toast.warn("Please enter valid email address");
                    }
                  }
                }}
                onClick={() => {
                  setopenContryCode(false);
                }}
              />
            </div>
            <div className="sm:flex w-full space-y-5 sm:space-y-0 sm:space-x-10 lg:space-y-0">
              <div className="w-full lg:w-2/5 grid-rows-5 relative">
                <PassengerDetailInputField
                  className="text-sm py-1 text-gray-700"
                  label="Country & Code*"
                  inputType="text"
                  icon={faGlobe}
                  placeHolder="Select Country and code"
                  value={
                    passenger.country
                      ? passenger.country + "      " + passenger.dial_code
                      : searchCountryCode
                  }
                  onClick={() => {
                    setopenContryCode(true);
                    setPassenger({
                      ...passenger,
                      country: "",
                      dial_code: "",
                    });
                  }}
                  onChange={(e) => {
                    setsearchCountryCode(e.target.value);
                  }}
                  onFocus={() => {
                    setopenContryCode(true);
                    setPassenger({
                      ...passenger,
                      country: "",
                      dial_code: "",
                    });
                  }}
                />
                <div className="absolute top-[3.6rem]">
                  {openContryCode && (
                    <div className="bg-white translate-y-64 absolute w-52 h-60 overflow-y-auto mx-1 scrollbar rounded-bl-md rounded-br-md border bottom-2 shadow-2xl">
                      {CountryList.map(
                        (country) =>
                          country.name
                            .toLowerCase()
                            .includes(searchCountryCode.toLowerCase()) && (
                            <div
                              onClick={(e) => {
                                setPassenger({
                                  ...passenger,
                                  country: country.name,
                                  dial_code: country.dial_code,
                                });
                                setopenContryCode(false);
                              }}
                              className="flex justify-between space-y-2 px-3 py-2 items-center cursor-pointer hover:bg-secondary hover:text-white text-sm"
                            >
                              <div className="">{country.name}</div>
                              <div className="font-normal">
                                {country.dial_code}
                              </div>
                            </div>
                          )
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full grow">
                <PassengerDetailInputField
                  label="Phone Number*"
                  inputType="number"
                  icon={faMobile}
                  placeHolder="Enter Phone Number"
                  onChange={(e) => {
                    setPassenger({ ...passenger, phone: e.target.value });
                  }}
                  onClick={() => {
                    setopenContryCode(false);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="sm:flex space-y-5 sm:space-y-0 sm:space-x-10">
            <div className="w-full grow">
              <PassengerDetailInputField
                label="Flight Number*"
                inputType="text"
                icon={faPlaneUp}
                placeHolder="Flight (Must for Airport/Station Pickup & Drop)"
                onChange={(e) => {
                  setcheckFlight(false);
                  dispatch(
                    setFlightData({
                      flightData: {},
                    })
                  );
                  setPassenger({
                    ...passenger,
                    flightOrTrain: e.target.value,
                  });
                }}
                onClick={() => {
                  setopenContryCode(false);
                }}
                onBlur={() => {
                  setcheckFlight(true);
                  if (
                    booking?.source?.placename?.includes("Airport") ||
                    booking?.source?.placename?.includes("airport") ||
                    booking?.source?.placename?.includes("AIRPORT") ||
                    booking?.source?.placename?.includes("مَطَار") ||
                    booking?.source?.placename?.includes("Aéroport") ||
                    booking?.source?.placename?.includes("Aeroporto") ||
                    booking?.source?.placename?.includes("Aeropuerto") ||
                    booking?.source?.placename?.includes("Flughafen")
                  ) {
                    if (passenger?.flightOrTrain) {
                      dispatch({
                        type: "GET_FLIGHT_DATA_ARRIVAL",
                        payload: {
                          flightNumberIata: passenger?.flightOrTrain,
                          year: moment(booking?.travelDate).format("YYYY"),
                          month: moment(booking?.travelDate).format("MM"),
                          date: moment(booking?.travelDate).format("DD"),
                        },
                      });
                    }
                  }

                  if (
                    booking?.destination?.placename?.includes("Airport") ||
                    booking?.destination?.placename?.includes("airport") ||
                    booking?.destination?.placename?.includes("AIRPORT") ||
                    booking?.destination?.placename?.includes("مَطَار") ||
                    booking?.destination?.placename?.includes("Aéroport") ||
                    booking?.destination?.placename?.includes("Aeroporto") ||
                    booking?.destination?.placename?.includes("Aeropuerto") ||
                    booking?.destination?.placename?.includes("Flughafen")
                  ) {
                    if (passenger?.flightOrTrain) {
                      dispatch({
                        type: "GET_FLIGHT_DATA_DEPARTURE",
                        payload: {
                          flightNumberIata: passenger?.flightOrTrain,
                          year: moment(booking?.travelDate).format("YYYY"),
                          month: moment(booking?.travelDate).format("MM"),
                          date: moment(booking?.travelDate).format("DD"),
                        },
                      });
                    }
                  }
                }}
              />
              {flightArrivalDepartureData?.arrivalTime && (
                <>
                  {(booking?.source?.placename?.includes("Airport") ||
                    booking?.source?.placename?.includes("airport") ||
                    booking?.source?.placename?.includes("AIRPORT") ||
                    booking?.source?.placename?.includes("مَطَار") ||
                    booking?.source?.placename?.includes("Aéroport") ||
                    booking?.source?.placename?.includes("Aeroporto") ||
                    booking?.source?.placename?.includes("Aeropuerto") ||
                    booking?.source?.placename?.includes("Flughafen")) && (
                    <div className="flex space-x-2 items-center pt-2">
                      <FontAwesomeIcon
                        icon={faPlaneArrival}
                        className="text-green-500"
                      />
                      <div className="text-sm">Arrival Time: </div>
                      {flightArrivalDepartureData?.arrivalTime && (
                        <div className="text-green-500 font-semibold">
                          {moment(
                            flightArrivalDepartureData?.arrivalTime
                          ).format("MMMM Do YYYY h:mm A")}
                        </div>
                      )}
                    </div>
                  )}
                  {(booking?.destination?.placename?.includes("Airport") ||
                    booking?.destination?.placename?.includes("airport") ||
                    booking?.destination?.placename?.includes("AIRPORT") ||
                    booking?.destination?.placename?.includes("مَطَار") ||
                    booking?.destination?.placename?.includes("Aéroport") ||
                    booking?.destination?.placename?.includes("Aeroporto") ||
                    booking?.destination?.placename?.includes("Aeropuerto") ||
                    booking?.destination?.placename?.includes("Flughafen")) && (
                    <div className="flex space-x-2 items-center pt-2">
                      <FontAwesomeIcon
                        icon={faPlaneDeparture}
                        className="text-green-500"
                      />
                      <div className="text-sm">Departure Time: </div>
                      {flightArrivalDepartureData?.departureTime && (
                        <div className="text-green-500 font-semibold">
                          {moment(
                            flightArrivalDepartureData?.departureTime
                          ).format("MMMM Do YYYY h:mm A")}
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
              {flightArrivalDepartureErrorData && (
                <div className="text-red-500 text-sm pt-2">
                  {flightArrivalDepartureErrorData}
                </div>
              )}
            </div>
            <div className="w-full grow">
              <PassengerDetailInputField
                label="Special Request"
                inputType="text"
                icon={faListCheck}
                placeHolder="Special Request (if any)"
                onChange={(e) => {
                  setPassenger({
                    ...passenger,
                    specialRequest: e.target.value,
                  });
                }}
                onClick={() => {
                  setopenContryCode(false);
                }}
              />
            </div>
          </div>

          <div className="sm:flex sm:space-x-16 md:flex lg:space-x-10 lg:flex-row space-x-0 md:space-x-0 justify-between">
            <div className="flex space-x-2 text-sm items-center">
              <input
                type="checkbox"
                className="cursor-pointer"
                onClick={(e) => {
                  setisPassengerDetailCheck(e.target.checked);
                  setopenContryCode(false);
                }}
              />

              <div>
                I agree to{" "}
                <span className="text-primary">
                  <Link
                    target="_blank"
                    className="text-secondary hover:underline"
                    to="/termsAndConditions"
                  >
                    Terms and Condition
                  </Link>
                  ,{" "}
                  <Link
                    target="_blank"
                    className="text-secondary hover:underline"
                    to="/bookingConditions"
                  >
                    Booking Conditions
                  </Link>{" "}
                  and{" "}
                  <Link
                    target="_blank"
                    className="text-secondary hover:underline"
                    to="/privacyPolicy"
                  >
                    Privacy Policy
                  </Link>
                  .
                </span>{" "}
              </div>
            </div>
            {!bookingInitiateLoading ? (
              <button
                onClick={confirmBookingHandler}
                className="w-full sm:w-1/3 mt-5 md:mt-5 sm:mt-0 lg:mt-0 capitalize text-white font-normal bg-secondary hover:text-black hover:bg-gray-300 cursor-pointer py-1.5 md:text-md md:px-10 lg:px-16 md:py-2 2xl:py-2 rounded-sm"
              >
                Confirm Booking
              </button>
            ) : (
              <>
                <div className="w-52">
                  <LoadingIcon />
                </div>
              </>
            )}
          </div>
        </div>
        {/* passenger details field */}
        <div></div>
      </div>
    </div>
  );
};

export default React.memo(PassengerDetail);
